/**
 * Format date as YY-MM-DD HH:mm
 * @param {string|Date} timestamp - The timestamp to format
 * @returns {string} - Formatted date string
 */
export const formatDate = (timestamp) => {
    if (!timestamp) return "Unknown"

    const date = new Date(timestamp)
    const year = date.getFullYear().toString().slice(2) // YY
    const month = String(date.getMonth() + 1).padStart(2, "0") // MM
    const day = String(date.getDate()).padStart(2, "0") // DD
    const hours = String(date.getHours()).padStart(2, "0") // HH
    const minutes = String(date.getMinutes()).padStart(2, "0") // mm

    return `${year}-${month}-${day} ${hours}:${minutes}`
}

/**
 * Format timestamp to human-readable relative time
 * @param {string|Date} timestamp - The timestamp to format
 * @returns {string} - Relative time string
 */
export const getRelativeTimeString = (timestamp) => {
    if (!timestamp) return "Unknown"

    const date = new Date(timestamp)
    const now = new Date()
    const diffMs = now - date
    const diffSeconds = Math.floor(diffMs / 1000)
    const diffMinutes = Math.floor(diffSeconds / 60)
    const diffHours = Math.floor(diffMinutes / 60)
    const diffDays = Math.floor(diffHours / 24)
    const diffWeeks = Math.floor(diffDays / 7)
    const diffMonths = Math.floor(diffDays / 30)
    const diffYears = Math.floor(diffDays / 365)

    if (diffSeconds < 60) return "Just now"
    if (diffMinutes < 60)
        return `${diffMinutes} ${diffMinutes === 1 ? "minute" : "minutes"} ago`
    if (diffHours < 24)
        return `${diffHours} ${diffHours === 1 ? "hour" : "hours"} ago`
    if (diffDays < 7)
        return `${diffDays} ${diffDays === 1 ? "day" : "days"} ago`
    if (diffWeeks < 4)
        return `${diffWeeks} ${diffWeeks === 1 ? "week" : "weeks"} ago`
    if (diffMonths < 12)
        return `${diffMonths} ${diffMonths === 1 ? "month" : "months"} ago`
    return `${diffYears} ${diffYears === 1 ? "year" : "years"} ago`
}

export default {
    formatDate,
    getRelativeTimeString
}